// /redeem?code=…: where invite links (join someone's Super plan) and gift links land. Signed in, the code
// is redeemed for this account; signed out, the person signs in first and the code waits here.
import React from 'react';
import { useRoute, type RouteProp } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { Body, Screen, Title } from '../components/ui';
import { useAccount } from '../store/account';
import { useNav, type AllParams } from '../navigation';
import { Redeem, SignInFirst } from './SuperScreen';

export default function RedeemScreen() {
  const { t } = useTranslation();
  const nav = useNav();
  const code = useRoute<RouteProp<AllParams, 'Redeem'>>().params?.code ?? '';
  const signedIn = useAccount(s => !!s.user);
  return (
    <Screen>
      <Title>{t('plan.redeemTitle')}</Title>
      <Body secondary>{t('plan.redeemIntro')}</Body>
      {signedIn ? <Redeem initialCode={code} onDone={() => nav.navigate('Super')} /> : <SignInFirst />}
    </Screen>
  );
}
